import type { MemoryPhotoData } from '@/types'

// Width divided by height of the photo as it should look on screen.
export const getDisplayRatio = (photo: MemoryPhotoData): number => {
    return photo.rotate ? photo.height / photo.width : photo.width / photo.height
}

export const padNumber = (value: number): string => String(value).padStart(2, '0')
